/**
 * RehabProgress — Iter 133.
 *
 * Single combined page that replaces two previously-separate patient views:
 *   - /patient/hep-progress → gamification (streak, adherence, badges)
 *   - /patient/progress     → clinical progress (VAS graph, outcomes)
 *
 * Same page is served for /patient/rehab-progress AND the legacy routes
 * so existing bookmarks keep working. Uses vertical section-stacking (no
 * tabs) — patients scroll through streak / trend / measures top-to-bottom.
 */
import React from 'react';
import PatientHepGamification from './PatientHepGamification';
import PatientProgress from '../PatientProgress';

export default function RehabProgress() {
  return (
    <div className="space-y-6" data-testid="rehab-progress-combined">
      {/* Header shown once at the top; child components have their own
          inner headings but the top-level "Rehab progress" title anchors
          the page + gives the sidebar link its destination. */}
      <div className="p-6 md:p-8 pb-0">
        <div className="text-xs uppercase tracking-[0.2em] text-accent font-medium mb-2">RECOVERY</div>
        <h1 className="text-3xl md:text-4xl font-heading font-bold tracking-tight">Rehab progress</h1>
        <p className="text-fg-muted mt-2 max-w-2xl">
          Your streak, adherence, and how your pain and outcome scores are
          trending — all in one place.
        </p>
      </div>
      {/* Gamification block (streak + badges + weekly progress). */}
      <PatientHepGamification/>
      {/* Clinical progress block (VAS chart + outcome measures). */}
      <PatientProgress/>
    </div>
  );
}
